import { MatchChronology } from './tables/match-chronology';
import Device from './tables/device';
import Broadcast from './tables/broadcast';
import Notifications from './tables/notifications';
import OrganizerLogoBacking from './tables/organizer-logo-backing';
import Overlay from './tables/overlay';
import OverlayLogs from './tables/overlay-logs';
import TmBoards from './tables/tm-boards';
import { createClient } from '@supabase/supabase-js';
import { RealtimePingPong } from './realtime-ping-pong';
import { RealtimeSocketMonitor } from './realtime-socket-monitor';

export class Supabase {
  supabase;
  matchChronology;
  organizerLogoBacking;
  overlay;
  overlayLogs;
  tmBoards;
  notifications;
  device;
  broadcast;
  pingPong;
  socketMonitor;

  constructor() {
    if (!process.env.REACT_APP_SUPABASE_URL) {
      throw new Error('REACT_APP_SUPABASE_URL is not set');
    }

    if (!process.env.REACT_APP_SUPABASE_KEY) {
      throw new Error('REACT_APP_SUPABASE_KEY is not set');
    }

    this.supabase = createClient(process.env.REACT_APP_SUPABASE_URL, process.env.REACT_APP_SUPABASE_KEY);

    this.matchChronology = new MatchChronology(this.supabase);
    this.organizerLogoBacking = new OrganizerLogoBacking(this.supabase);
    this.overlay = new Overlay(this.supabase);
    this.overlayLogs = new OverlayLogs(this.supabase);
    this.tmBoards = new TmBoards(this.supabase);
    this.notifications = new Notifications(this.supabase);
    this.device = new Device(this.supabase);
    this.broadcast = new Broadcast(this.supabase);
    this.pingPong = new RealtimePingPong(this.supabase);
    this.socketMonitor = new RealtimeSocketMonitor(this.supabase);
  }
}

const supabase = new Supabase();
export default supabase;
